import { Star } from "lucide-react";
import { cn } from "../lib/utils";

const MAX_STARS = 5;

export interface StarRatingProps {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
  className?: string;
}

export function StarRating(props: StarRatingProps) {
  const { value, onChange, disabled = false, className } = props;
  return (
    <div
      className={cn("flex items-center gap-0.5", className)}
      role="group"
      aria-label="Rating"
    >
      {Array.from({ length: MAX_STARS }, (_, i) => {
        const starValue = i + 1;
        const filled = value >= starValue;
        return (
          <button
            key={starValue}
            type="button"
            disabled={disabled}
            onClick={() => onChange(starValue)}
            className={cn(
              "p-0.5 rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
              disabled && "cursor-not-allowed opacity-60",
              !disabled && "hover:scale-110"
            )}
            aria-label={`${starValue} of ${MAX_STARS} stars`}
            aria-pressed={filled}
          >
            <Star
              className={cn(
                "h-6 w-6",
                filled
                  ? "fill-amber-400 text-amber-400"
                  : "fill-transparent text-muted-foreground"
              )}
            />
          </button>
        );
      })}
    </div>
  );
}
